module.exports = __webpack_public_path__ + "img/equip-layer.473c2a69.png";